export const UPDATE_PARTNER = "UPDATE_PARTNER";
export const GET_SELECTED_PARTNER = "UPDATE_PARTNER";
export const CREATE_PARTNER = 'CREATE_PARTNER'